/*Keycloak setup infos*/
const keycloak = {
  url: "https://app.driveb.com.br/auth/",
  realm: "smart-fleet",
  clientId: "driveb-frontend"
};

const apiUrl = "https://app.driveb.com.br/api/";

export const environment = {
  production: true,
  apiUrl,
  apiV2Url: `${apiUrl}v2/`,
  microserviceErp: "https://app.driveb.com.br/erp/",
  microserviceParts: "https://app.driveb.com.br/parts/",
  microserviceSales: "https://app.driveb.com.br/sales/",
  microserviceReportApiUrl: "https://app.driveb.com.br/generated-reports/",
  microserviceBotPriceCheck:
    "https://app.driveb.com.br/price-check-integrator/",
  microserviceCarWorkshopAgendaApiUrl:
    "https://app.driveb.com.br/car-workshop/",
  microserviceCarWorkshopChecklistApiUrl:
    "https://app.driveb.com.br/checklist/",
  keycloack: keycloak,
  messageDelay: 5000,
  logoutUrl: `${window.location.origin}/`,
  googleMapsKey: "#{GOOGLE_MAPS_KEY}#",
  defaultLocale: "pt-BR",
  firebase: {
    apiKey: "AIzaSyBRqrLE1dLri7MwLyFtT6EJbESHzGdS0ZA",
    authDomain: "driveb-cd469.firebaseapp.com",
    projectId: "driveb-cd469",
    storageBucket: "driveb-cd469.appspot.com",
    messagingSenderId: "934549158578",
    appId: "1:934549158578:web:f5ae8ba399f941565a67ab",
    measurementId: "G-9Y956GWJK6"
  }
};
